import { koComponent } from '../../ko-utils';
import * as siteConfig from '../../site-config/trackableConfig';
import languages from '../../utils/languages';
import { beginNoTracking, endNoTracking } from '../../utils/changeTracking';

class TourMinimizationDescriptor {
    constructor(params) {
        this.root = params.rootElement;

        if (!this.root()) {
            beginNoTracking(this.root);
            this.root(new siteConfig.TourMinimizationDescriptor());
            endNoTracking(this.root);

            beginNoTracking(this.root());
            this.root().enabled(false);
            endNoTracking(this.root());
        }

        this.selectedLanguage = ko.observable(window.auth.project.SupportedLanguages[0]);
        this.supportedLanguages = languages.filter(i => window.auth.project.SupportedLanguages.indexOf(i.alpha2) !== -1);
    }

    get bindingCtx() {
        const v = this.root();

        if (!v) return {};

        return v;
    }

    bindLocalizableProp(observable) {
        return ko.computed({
            read: () => {
                var val = ko.unwrap(observable);
                if (!val) {
                    return undefined;
                }

                return ko.unwrap(observable()[this.selectedLanguage()]);
            },
            write: (val) => {
                var curV = ko.unwrap(observable);

                if (!curV) {
                    curV = {};
                }

                curV[this.selectedLanguage()] = val;

                typeof observable === 'function' && observable(curV);
            }
        });
    }
}

export default koComponent('tour-minimization-descriptor', TourMinimizationDescriptor);